var _UTM_SHARE_TYPE_MAP;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
export var SHARE_ON_EMAIL = 'email';
export var SHARE_ON_FACEBOOK = 'facebook';
export var SHARE_ON_FACEBOOK_MESSENGER = 'facebookMessenger';
export var SHARE_ON_TWITTER = 'twitter'; // share components should be ordered as: facebook, facebookMessenger, twitter, email
// don't change the order unless you're totally sure about what you're doing

export var SHARE_TYPES = [SHARE_ON_FACEBOOK, SHARE_ON_FACEBOOK_MESSENGER, SHARE_ON_TWITTER, SHARE_ON_EMAIL];
export var DEFAULT_UTM_OPTIONS = {
  'utm-campaign': 'social',
  'utm-content': 'attendeeshare',
  'utm-medium': 'discovery',
  'utm-source': '',
  'utm-term': 'checkoutwidget'
};
export var UTM_SHARE_TYPE_MAP = (_UTM_SHARE_TYPE_MAP = {}, _defineProperty(_UTM_SHARE_TYPE_MAP, SHARE_ON_FACEBOOK, {
  'utm-source': 'fb'
}), _defineProperty(_UTM_SHARE_TYPE_MAP, SHARE_ON_FACEBOOK_MESSENGER, {
  'utm-source': 'fbm'
}), _defineProperty(_UTM_SHARE_TYPE_MAP, SHARE_ON_TWITTER, {
  'utm-source': 'tw'
}), _defineProperty(_UTM_SHARE_TYPE_MAP, SHARE_ON_EMAIL, {
  'utm-campaign': 'social,email',
  'utm-source': 'strongmail'
}), _UTM_SHARE_TYPE_MAP);
export var FACEBOOK_PROP_TYPE_SHAPE = PropTypes.shape({
  appId: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
  xfbml: PropTypes.bool.isRequired
});
export var UTM_OPTION_PROPTYPE = PropTypes.shape({
  'utm-campaign': PropTypes.string,
  'utm-content': PropTypes.string,
  'utm-medium': PropTypes.string,
  'utm-source': PropTypes.string,
  'utm-term': PropTypes.string
});